<div class="confirm-dialog">
  <div class="confirm-dialog-header">
    <h4><i class="fa fa-question-circle"></i> {{ data.title }}</h4>
  </div>
  <div class="confirm-dialog-body">
    <p>{{ data.message }}</p>
  </div>
  <div class="confirm-dialog-footer">
    <button type="button" class="btn btn-default btn-flat" (click)="onCancel()">
      {{ data.cancelText || 'Annuler' }}
    </button>
    <button type="button" class="btn btn-danger btn-flat" (click)="onConfirm()">
      {{ data.confirmText || 'Confirmer' }}
    </button>
  </div>
</div>
